import React from "react";
import AddressForm from "../../forms/account/AddressForm";
import EditSupportContainer from "../../containers/support/EditSupportContainer";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const Edit = ({ handleClose, open, address }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("register.title_edit_address")}
    >
      {address ? (
        <EditSupportContainer support={address}>
          {({ onSubmit, support }) => (
            <AddressForm onSubmit={onSubmit} initialValues={support.profile} />
          )}
        </EditSupportContainer>
      ) : null}
    </Modal>
  );
};

export default Edit;
